export default __webpack_public_path__ + "static/media/IMG_9954.00ba3515.jpeg";